import React from 'react';
import { ThemeProvider, injectGlobal } from 'styled-components';
import { Theme } from '../../legacy/hui/src/styled';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Redirect, Switch } from 'react-router-dom';
import { normalize } from 'polished';
import { connect } from 'react-redux';
import { HeaderBunnings } from '../components/HeaderBunnings';
import { FooterBunnings } from '../components/FooterBunnings';
import FavIcon from '../images/favicon-bunnings.png';

injectGlobal`
  ${normalize()}
  
  * {
    min-height: 0;
    min-width: 0;
    box-sizing: border-box;
  }
  body {
    background: #ECECEC;
  }

  .ReactModal__Body--open {
    overflow: hidden;
  }

  html, body, button, input, optgroup, select, textarea {
    font-family: Source Sans Pro, sans-serif;
  }
`;

const App = ({ children, location }) => {
  return (
    <ThemeProvider theme={Theme}>
      <div>
        <Helmet
          defaultTitle="Book and manage your Bunnings Product Installation | Powered by hipages"
          titleTemplate="%s  - hipages.com.au"
        >
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta property="fb:app_id" content="102132386588242" />
          <meta property="og:type" content="article" />
          <meta property="og:site_name" content="Home Improvement Pages" />
          <meta name="classification" content="Home Improvement" />
          <meta name="author" content="Home Improvement Pages Australia" />
          <meta name="Reply-to" content="info@homeimprovementpages.com.au" />
          <meta name="copyright" content="2004 Home Improvement Pages Australia" />
          <link
            rel="alternate"
            type="application/rss+xml"
            title="RSS 2.0"
            href="//feeds.feedburner.com/hipages"
          />
          <link rel="shortcut icon" type="image/ico" href={FavIcon} />
          <meta name="msapplication-TileColor" content="#faa25c" />
          <meta name="robots" content="noindex" />
        </Helmet>
        <HeaderBunnings siteSource={'Bunnings'} path={location.pathname} />
        <Switch>
          <Redirect from="/" to="/install" exact strict />
        </Switch>
        {children}
        <FooterBunnings siteSource={'Bunnings'} path={location.pathname} />
      </div>
    </ThemeProvider>
  );
};

App.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object
};

export default connect(null, null)(App);
